import { User } from 'api/types/user';

const REQUIRED_USER_FIELDS: (keyof User)[] = ['firstName', 'lastName'];

export const hasRequiredFields = (user: User | null): boolean => {
  return REQUIRED_USER_FIELDS.every((field) => !!user?.[field]);
};
